<div
  class="m-1 w-fit rounded-xl border border-(--content-neutral-secondary) opacity-90 shadow"
  [ngClass]="bgColorClass()"
>
  <span class="flex gap-2 px-3 py-1 text-(--content-neutral-secondary) text-shadow-md">
    <nsp-icon [name]="iconName()" />
    <div class="stroke-black font-bold">{{ reportTypeDisplay() }}</div>
  </span>
</div>
